import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ToasterServiceService } from '../service/toaster.service';
import { MainService } from '../service/main.service';
import { LocalStorageService } from '../service/local-storage.service';
import { ApiUrls } from '../apiRouts';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CapacitorBarcodeScanner, CapacitorBarcodeScannerCameraDirection, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';

@Component({
  selector: 'app-qr-scanner',
  templateUrl: './qr-scanner.component.html',
  styleUrls: ['./qr-scanner.component.scss']
})
export class QrScannerComponent implements OnInit {

  tryHarder = false;
  userId: any;
  subEventId: any;
  
  constructor(
    private location: Location,
    private toasterService: ToasterServiceService,
    private mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
    });
  }

  ngOnInit(): void {
    this.scanQR();
  }

  scanQR() {
    CapacitorBarcodeScanner.scanBarcode({ hint: CapacitorBarcodeScannerTypeHint.ALL, cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK, scanInstructions: "Scan a QR code" }).then((value: any) => {
      console.log(value);
      this.onCodeResult(value.ScanResult);
    }).catch((error: any) => {
      this.toasterService.toastError("Scanning failed: " + error);
    });
    // Automatically select the back camera if available
    /*cordova.plugins.barcodeScanner.scan((result: any) => {
      this.onCodeResult(result.text);
    }, (error: any) => {
      this.toasterService.toastError("Scanning failed: " + error);
    }, {
      preferFrontCamera: false, // iOS and Android
      showFlipCameraButton: false, // iOS and Android
      showTorchButton: true, // iOS and Android
      torchOn: false, // Android, launch with the torch switched on (if available)
      saveHistory: false, // Android, save scan history (default false)
      prompt: "Place a barcode inside the scan area", // Android
      resultDisplayDuration: 100, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
      formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
      orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
      disableAnimations: true, // iOS
      disableSuccessBeep: false // iOS and Android
    });*/
  }


  goBackToPrevPage(): void {
    this.location.back();
  }

  onCodeResult(resultString: string) {
    console.log("resultString ", resultString);
    if (Number(resultString)) {
      var data: any = {
        event_attendance_id: 0,
        created_by: this.userId,
        attendance_time: '',
        sub_event_member_id: Number(resultString),
        sub_event_id: Number(this.subEventId),
        Action: 'INSERT'
      }

      this.mainService.postApi(ApiUrls.attendanceMember, data, 1).subscribe(res => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);

          setTimeout(() => {
            this.scanQR();
          }, 3000);
        } else {
          this.toasterService.toastError(res.response);
        }
      });
    }
    else if (resultString.length > 0) {
      this.scanQR();
    }
  }

  GotoInvitation() {
    this.router.navigate(["/menunal-invitation-present-member/" + this.subEventId]);
  }
}
